import authService from "@api/authService";

const actions = {
    authRequest: ({ commit, dispatch }, payload) => {
        let actionUrl = "login";
        let remember = payload.remember ? payload.remember : false;
        let data = {
            username: payload.username,
            password: payload.password,
            xyz: payload.xyz,
            zyx: payload.zyx,
        };

        if (payload.action == "register") {
            actionUrl = "register";
            data = {
                username: payload.username,
                firstname: payload.firstname,
                lastname: payload.lastname,
                dob: payload.dob,
                gender: payload.gender,
                email: payload.email,
                mobile: payload.mobile,
                phone: payload.phone,
                workphone: payload.workphone,
                address: payload.address,
                suburb: payload.suburb,
                state: payload.state,
                postcode: payload.postcode,
                password: payload.password,
                password_confirmation: payload.password_confirmation,
                agreed_to_terms: payload.agreed_to_terms,
                agreed_to_privacy: payload.agreed_to_privacy,
                agreed_to_indemnity: payload.agreed_to_indemnity,
                np: payload.np,
                ec_fullname: payload.ec_fullname,
                ec_mobile: payload.ec_mobile,
                sport: payload.sport,

                middlename: payload.middlename,
                prefname: payload.prefname,
                disability: payload.disability,
                disabilitytype: payload.disabilitytype,
                identifygender: payload.identifygender,
                countrybirth: payload.countrybirth,
                statebirth: payload.statebirth,
                aboriginal: payload.aboriginal,
                ec_medical: payload.ec_medical
            };
        }

        return new Promise((resolve, reject) => {
            commit("AUTH_REQUEST");

            authService
                .request(actionUrl, data)
                .then(resp => {
                    let access_token = "Bearer " + JSON.parse(resp.data.success).access_token;
                    Cookies.set("access_token", access_token, { expires: remember ? 365 : 1 });
                    axios.defaults.headers.common["Authorization"] = access_token;

                    commit("AUTH_SUCCESS", access_token);
                    return dispatch("user/userRequest", null, { root: true }).then(() => {
                        commit("product/REMOVE_CART", null, { root: true });
                        resolve();
                    });
                })
                .catch(err => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    try {
                        if (_.isString(errors) && (JSON.parse(errors).error == "invalid_credentials" || JSON.parse(errors).error == "invalid_grant")) {
                            errors = {
                                error: {
                                    invalid_credentials:
                                        'Please note usernames & passwords are case sensitive. As a first measure, please utilise the "forgot username" or "forgot/reset your password" facility below to assist. Should you still be unable to login please, email us or contact us.',
                                },
                            };
                        }
                    } catch (e) {
                        errors = {
                            error: {
                                invalid_credentials: "Technical issue, please try again later.",
                            },
                        };
                    }

                    commit("AUTH_ERROR", errors);
                    Cookies.remove("access_token");
                    reject(err.response);
                });
        });
    },
    sendPwdEmail: ({ commit, dispatch }, payload) => {
        let data = {
            username: payload.username,
        };

        return new Promise((resolve, reject) => {
            commit("AUTH_REQUEST");

            authService
                .sendPwdEmail(data)
                .then(resp => {
                    commit("AUTH_PWD_EMAIL");
                    resolve(resp);
                })
                .catch(err => {
                    let errors = err.response.data;

                    if (_.isString(err) && JSON.parse(err).error == "invalid_credentials") {
                        errors = {};
                        errors.invalid_credentials = ["Incorrect username or password."];
                    }

                    commit("AUTH_ERROR", errors);
                    reject(err.response);
                });
        });
    },
    sendUsernameEmail: ({ commit, dispatch }, payload) => {
        let data = {
            email: payload.email,
        };

        return new Promise((resolve, reject) => {
            commit("AUTH_REQUEST");

            authService
                .sendUsernameEmail(data)
                .then(resp => {
                    commit("AUTH_USERNAME_EMAIL");
                    resolve(resp);
                })
                .catch(err => {
                    let errors = err.response.data;

                    commit("AUTH_ERROR", errors);
                    reject(err.response);
                });
        });
    },
    resetPwdEmail: ({ commit, dispatch }, payload) => {
        let data = {
            token: payload.token,
            username: payload.username,
            password: payload.password,
            password_confirmation: payload.password_confirmation,
        };

        return new Promise((resolve, reject) => {
            commit("AUTH_REQUEST");

            authService
                .resetPwdEmail(data)
                .then(resp => {
                    let successResponse = JSON.parse(resp.data.success);
                    let access_token = "Bearer " + successResponse.access_token;
                    Cookies.set("access_token", access_token, { expires: 365 });
                    axios.defaults.headers.common["Authorization"] = access_token;

                    commit("AUTH_SUCCESS", access_token);
                    return dispatch("user/userRequest", null, { root: true }).then(() => {
                        commit("product/REMOVE_CART", null, { root: true });
                        resolve(access_token);
                    });
                })
                .catch(err => {
                    let errors = err.response.data.errors ? err.response.data.errors : err.response.data;

                    if (_.isArray(err.response.data.error)) {
                        errors = {};
                        errors.invalid_username = [err.response.data.error[0]];
                    }

                    commit("AUTH_ERROR", { error: errors });
                    reject(err.response);
                });
        });
    },
    clearErrors: ({ commit }) => {
        commit("CLEAR_ERRORS");
    },
    authLogout: context => {
        Cookies.remove("access_token");

        return new Promise((resolve, reject) => {
            authService
                .logout()
                .then(() => {
                    context.commit("hpcsubscription/RESET_STATE", null, { root: true });
                    context.commit("hpcenroll/RESET_STATE", null, { root: true });
                    context.commit("classes/RESET_STATE", null, { root: true });
                    context.commit("plans/RESET_STATE", null, { root: true });
                    context.commit("donation/RESET_STATE", null, { root: true });
                    context.commit("coupon/RESET_STATE", null, { root: true });
                    context.commit("coupon/REMOVE_VOUCHER", null, { root: true });
                    // context.commit("invoice/REMOVE_CONDITION", null, { root: true });
                    // context.commit("product/REMOVE_CONDITION", null, { root: true });

                    context.commit("product/RESET_STATE", null, { root: true });
                    context.commit("product/REMOVE_CART", null, { root: true });
                    context.commit("booking/RESET_STATE", null, { root: true });
                    context.commit("teamnomination/RESET_STATE", null, { root: true });
                    context.commit("membership/RESET_STATE", null, { root: true });
                    context.commit("referee/RESET_STATE", null, { root: true });
                    context.commit("roster/RESET_STATE", null, { root: true });
                    context.commit("invoice/RESET_STATE", null, { root: true });
                    context.commit("order/RESET_STATE", null, { root: true });
                    context.commit("payment/RESET_STATE", null, { root: true });
                    context.commit("team/RESET_STATE", null, { root: true });
                    context.commit("stats/RESET_STATE", null, { root: true });
                    context.commit("user/RESET_STATE", null, { root: true });

                    context.commit("RESET_STATE");
                    context.commit("AUTH_LOGOUT");
                    resolve();
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
};

export default actions;
